import React, { FC, useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { BusinessTeaser } from 'components/BusinessTeaser';
import ArrowleftIcon from 'icons/Arrowleft.icon';
import { getCreateListingRoute } from 'utils';
import { useFormState } from 'react-final-form';
import { Listing } from 'models/Listing';
import { EDIT_ROUTE, LCW_STATEMENT_OF_INFORMATION_ROUTE } from 'data/global';

import './TeaserPreview.styles.scss';

const TeaserPreview: FC = () => {
  const { pathname } = useLocation();
  const isEdit = pathname.includes(EDIT_ROUTE);
  const { t } = useTranslation();

  const { values: listing } = useFormState<Listing>();

  const { dealRoomId, type, _id: listingId } = listing;

  const backLink = useMemo(
    () =>
      `${getCreateListingRoute(
        dealRoomId,
        listingId,
        type,
        isEdit,
      )}/${LCW_STATEMENT_OF_INFORMATION_ROUTE}`,
    [dealRoomId, isEdit, listingId, type],
  );

  return (
    <div className="listing-details-teaser">
      <Link to={backLink} className="back-button">
        <ArrowleftIcon />
        {t('backToFormView')}
      </Link>
      <BusinessTeaser listing={listing} areActionsDisabled />
    </div>
  );
};

export default TeaserPreview;
